import '../click/isClickableInput.js';
import '../dataTransfer/Clipboard.js';
import './maxLength.js';
import { isContentEditable } from './isContentEditable.js';
import './isEditable.js';
import '@testing-library/dom';
import '@testing-library/dom/dist/helpers.js';
import '../keyDef/readNextDescriptor.js';
import '../misc/level.js';
import '../../options.js';
import '../../event/eventMap.js';
import '../../event/behavior/click.js';
import '../../event/behavior/cut.js';
import '../../event/behavior/keydown.js';
import '../../event/behavior/keypress.js';
import '../../event/behavior/keyup.js';
import '../../event/behavior/paste.js';
import { getUIValue } from '../../document/value.js';

function getValue(element) {
    // istanbul ignore if
    if (!element) {
        return null;
    }
    if (isContentEditable(element)) {
        return element.textContent;
    }
    return getUIValue(element);
}

export { getValue };
